import { useState } from "react";
import localAuthServices from "../localAuthServices";

function Logout() {

  var query = window.location.search.substring(1);
  var vars = query.split("&");
  var pair = vars[0].split("=");
  const [sourceDomain] = useState(pair[1]);

  const logout = () => {
    localAuthServices.removeToken()
    window.parent.postMessage({
      event_id: "sso_logout",
      token: localAuthServices.getToken()
    }, sourceDomain);
  }

  return (
    <><div>{logout()}</div></>
  )
}

export default Logout;